export default "__VITE_ASSET__95VIauFM__"